import * as React from 'react'
import { cn } from '@/utils/cn'

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'>
>(({ className, ...props }, ref) => (
  <textarea
    className={cn(
      'flex min-h-[88px] w-full rounded-lg border border-input/90 field-glass px-3 py-2.5 text-sm transition-colors duration-150',
      'placeholder:text-xs placeholder:text-muted-foreground/70 md:placeholder:text-sm',
      'hover:border-border/80',
      'focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/20',
      'disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-60',
      className,
    )}
    ref={ref}
    {...props}
  />
))
Textarea.displayName = 'Textarea'

export { Textarea }
